import React, { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import { Tabindex } from '../../utils/typeConstants';
import { CaSearchTemplate } from '../../features/correctiveActions/searchCorrectiveActionTemplate/CaSearchTemplate';
import { CreateTemplateApprovalQueues } from '../../features/correctiveActions/caTemplateApprovalQueues/CreateTemplateApprovalQueues';
import { CaConfigure } from '../../features/correctiveActions/configureCorrectiveActionTemplate/CaConfigure';

export const CorrectiveActions = () => {
    const [activeIndex, setActiveIndex] = useState<number>(Tabindex.Search);
    const [selectedCountry, setSelectedCountry] = useState<any>({});
    const [selectedCategory, setSelectedCategory] = useState<any>({});
    const [selectedRole, setSelectedRole] = useState<any>({});
    const [selectedCaTemplate, setSelectedCaTemplate] = useState<any>({});
    const [selectedLanguage, setSelectedLanguage] = useState<number>()
    const [isUpdateApprovalQueues, setIsUpdateApprovalQueues] = useState<boolean>(false);
    
    const resetFilter = () => {
        setSelectedCountry({});
        setSelectedCategory({});
        setSelectedRole({});
        setSelectedLanguage(undefined);
        setIsUpdateApprovalQueues(false);
        window.localStorage.removeItem('country')
        window.localStorage.removeItem('category');
        window.localStorage.removeItem('role');
    }

    return (
        <div>
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <TabView
                                activeIndex={activeIndex}
                                onTabChange={(e) => {
                                    console.log(e.index)
                                    if (e.index === 0)
                                        resetFilter();
                                    setActiveIndex(e.index);
                                }}
                            >
                                <TabPanel header="Search">
                                    <CaSearchTemplate
                                        selectedCountry={selectedCountry}
                                        selectedCategory={selectedCategory}
                                        selectedRole={selectedRole}                                        
                                        setSelectedCountry={setSelectedCountry}
                                        setSelectedCategory={setSelectedCategory}
                                        setSelectedRole={setSelectedRole}
                                        setSelectedCaTemplate={setSelectedCaTemplate}
                                        setSelectedLanguage={setSelectedLanguage}
                                        resetFilter={resetFilter}
                                        setActiveIndex={setActiveIndex}
                                        setIsUpdateApprovalQueues={setIsUpdateApprovalQueues}
                                    />
                                </TabPanel>

                                {activeIndex === Tabindex.Configuration && (

                                    <TabPanel header="Configuration">
                                        <div className="card border-0 p-3 ps-0">
                                            <div className="card-body p-0">
                                                <CaConfigure selectedCaTemplate={selectedCaTemplate}
                                                    selectedCountry={selectedCountry}
                                                    selectedCategory={selectedCategory}
                                                    selectedRole={selectedRole}
                                                    selectedLanguage={selectedLanguage}
                                                    setSelectedLanguage={setSelectedLanguage}
                                                    setIsUpdateApprovalQueues={setIsUpdateApprovalQueues}
                                                    setActiveIndex={setActiveIndex}
                                                />
                                            </div>
                                        </div>
                                    </TabPanel>
                                 )}
                                {activeIndex === Tabindex.Create && (
                                    <TabPanel header={!isUpdateApprovalQueues?"Create":"Configure"}>
                                        <CreateTemplateApprovalQueues
                                            selectedCountry={selectedCountry}
                                            selectedCategory={selectedCategory}
                                            selectedRole={selectedRole}
                                            selectedCaTemplate={selectedCaTemplate}
                                            selectedLanguage={selectedLanguage}
                                            setSelectedLanguage={setSelectedLanguage}
                                            setSelectedCaTemplate={setSelectedCaTemplate}                                           
                                            setActiveIndex={setActiveIndex}
                                            resetFilter={resetFilter}
                                            isUpdateApprovalQueues={isUpdateApprovalQueues}
                                        />
                                    </TabPanel>
                              )}
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
